import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(({ palette, spacing, breakpoints }) => ({
  header: {
    alignItems: "center",
    backgroundColor: palette.primary.main,
    color: palette.background.paper,
    display: "flex",
    fontSize: 16,
    height: spacing(8),
    justifyContent: "flex-end",
    left: spacing(8),
    position: "fixed",
    right: 0,
    top: 0,
    zIndex: 900,
    transition: "left 200ms",
    padding: "0 20px",

    [breakpoints.down("sm")]: {
      padding: 0,
    },

    "& .MuiButton-outlinedInherit": {
      borderColor: palette.common.white,
    },
  },

  "header--expanded": {
    [breakpoints.up("lg")]: {
      left: spacing(32),
    },
  },

  header__buttons: {
    display: "flex",
    alignItems: "center",
    gap: "32px",

    [breakpoints.down("md")]: {
      gap: "16px",
    },

    [breakpoints.down("sm")]: {
      gap: "12px",
    },
  },
}));
